<template>
    <el-dialog
        :title="mode === 'single' ? '新增单日排班' : '新增连续日排班'"
        :visible.sync="dialogVisible"
        width="600px"
        append-to-body
        @close="handleClose"
    >
        <el-form ref="formRef" :model="form" :rules="rules" label-width="100px" size="small">
            <el-form-item label="课程名称：">
                <el-input v-model="form.outline_name" placeholder="自动带出" readonly></el-input>
            </el-form-item>
            <el-form-item label="授课讲师：">
                <el-input v-model="form.instructor" placeholder="自动带出" readonly></el-input>
            </el-form-item>

            <template v-if="mode === 'single'">
                <el-form-item label="排班日期：" prop="schedule_date">
                    <el-date-picker
                        v-model="form.schedule_date"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        style="width: 100%;"
                    ></el-date-picker>
                </el-form-item>
            </template>

            <template v-else>
                <el-form-item label="日期范围：" prop="date_range">
                    <el-date-picker
                        v-model="form.date_range"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        style="width: 100%;"
                    ></el-date-picker>
                </el-form-item>
            </template>

            <el-form-item label="时间范围：" prop="time_range">
                <el-time-picker
                    v-model="form.time_range"
                    is-range
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="HH:mm"
                    style="width: 100%;"
                ></el-time-picker>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: "scheduleAdd",
    props: {
        outlineId: {
            type: String,
            default: ''
        },
        outlineName: {
            type: String,
            default: ''
        },
        instructor: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dialogVisible: false,
            mode: 'single',
            submitLoading: false,
            form: {
                outline_id: '',
                outline_name: '',
                instructor: '',
                schedule_date: '',
                date_range: '',
                time_range: '',
            },
            rules: {
                schedule_date: [
                    { required: true, message: '请选择排班日期', trigger: 'change' }
                ],
                date_range: [
                    { required: true, message: '请选择日期范围', trigger: 'change' }
                ],
                time_range: [
                    { required: true, message: '请选择时间范围', trigger: 'change' }
                ],
            },
        };
    },
    methods: {
        open(mode = 'single') {
            this.mode = mode;
            this.form.outline_id = this.outlineId;
            this.form.outline_name = this.outlineName;
            this.form.instructor = this.instructor;
            this.dialogVisible = true;
        },
        handleClose() {
            this.$refs.formRef && this.$refs.formRef.resetFields();
            this.form = {
                outline_id: '',
                outline_name: '',
                instructor: '',
                schedule_date: '',
                date_range: '',
                time_range: '',
            };
        },
        handleSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    if (this.form.time_range && this.form.time_range.length === 2) {
                        if (this.form.time_range[0] >= this.form.time_range[1]) {
                            this.$message({ type: 'error', message: '结束时间必须大于开始时间' });
                            return;
                        }
                    }
                    if (this.mode === 'continuous' && this.form.date_range && this.form.date_range.length === 2) {
                        if (this.form.date_range[1] < this.form.date_range[0]) {
                            this.$message({ type: 'error', message: '结束日期不能小于开始日期' });
                            return;
                        }
                    }
                    this.submitLoading = true;
                    const api = this.mode === 'single'
                        ? this.$baseUrl.hrcourseschedAddSingleDay
                        : this.$baseUrl.hrcourseschedAddContinuousDays;

                    const params = {
                        outline_id: this.form.outline_id,
                    };

                    if (this.mode === 'single') {
                        params.schedule_date = this.form.schedule_date;
                    } else {
                        params.start_date = this.form.date_range[0];
                        params.end_date = this.form.date_range[1];
                    }

                    if (this.form.time_range && this.form.time_range.length === 2) {
                        params.start_time = this.form.time_range[0];
                        params.end_time = this.form.time_range[1];
                    }

                    this.$tools.asyncPost(this, api, { data: params }).then((res) => {
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: this.mode === 'single' ? '添加单日排班成功' : '添加连续日排班成功'
                            });
                            this.dialogVisible = false;
                            this.$emit('ok');
                        } else {
                            this.$message({ type: 'error', message: res.data.msg });
                        }
                        this.submitLoading = false;
                    }).catch(() => {
                        this.submitLoading = false;
                    });
                }
            });
        },
    },
};
</script>
